<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#6452c5" type="ball-clip-rotate" [fullScreen]="true">
    <p class="loader"> Loading... </p>
</ngx-spinner>
<div class="table-box section">
    <div class="client-box">
        <div class="row">
            <div class="col-md-4 col-sm-12 col-12">
                <div class="box">
                    <label>Client name:</label>
                    <p class="word-break">{{clientName}}</p>
                </div>
                <div class="box">
                    <label>Contact name:</label>
                    <p class="word-break">{{contactName}}</p>
                </div>
                <div class="box">
                    <label>Monitoring frequency:</label>
                    <p>{{monitoringFrequency}}</p>
                </div>
            </div>
            <div class="col-md-4 col-sm-12 col-12">
                <div class="box">
                    <label>Email:</label>
                    <p class="word-break">{{email}}</p>
                </div>
                <div class="box">
                    <label>Contact no:</label>
                    <p>{{contactNo}}</p>
                </div>
                <div class="box">
                    <label>Payment profile:</label>
                    <p>{{paymentProfile}}</p>
                </div>
            </div>
            <div class="col-md-4 col-sm-12 col-12text-center">
                <div class="box">
                    <label>Expiry date:</label>
                    <p>{{expiryDate | date: "mediumDate"}}</p>
                </div>
                <div class="box">
                    <label>Status:</label>
                    <p *ngIf="isActive != 'Pendingapproval'">{{isActive}}</p>
                    <p *ngIf="isActive == 'Pendingapproval'">Pending approval</p>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="client-box" style="margin-top:10px;">
        <div class="row">
            <div class="col-sm-4 col-4">
                <label class="label">Monitoring Frequency</label>
                <select class="border-input sel-mat-inp select payment-select" id="monitoringFrequency">
                    <option hidden value="" disabled selected class="mrgl45">Select monitoring frequency</option>
                    <option value="Weekly">Weekly</option>
                    <option value="Monthly">Monthly</option>
                    <option value="Quarterly">Quarterly</option>
                    <option value="Yearly">Yearly</option>
                </select>
            </div>
            <div class="col-sm-4 col-4">
                <label class="label">Payment Profile</label>
                <select class="border-input sel-mat-inp select payment-select" id="paymentProfile">
                    <option hidden value="" disabled selected class="mrgl45">Select payment profile</option>
                    <option *ngFor="let paymentProfile of arrPaymentProfile let indexOfelement=index;"
                        value="{{paymentProfile.name}}"> {{paymentProfile.name}}</option>
                </select>
            </div>
            <div class="col-sm-4 col-4">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="d-flex btn-payment">
                            <button type="button" class="btn-wrap red-btn" (click)="CancelClientInfo();">
                                Cancel
                            </button>&nbsp;
                            <button type="button" class="btn-wrap btn-box" (click)="UpdateClientInfo(clientResponse)">
                                Update
                            </button>
                        </div>
                    </div>
                    <div class="col-sm-6"></div>
                </div>

            </div>
        </div>
        <div class="row" style="margin-top: -12px">
            <div class="col-sm-4 col-4">
              <span class="txt-error" *ngIf="submitted && monitoringFrequency == ''">
                Please select monitoring frequency
              </span>
            </div>
            <div class="col-sm-4 col-4">
              <span class="txt-error" *ngIf="submitted && paymentProfile == ''">
                Please select payment profile
              </span>
            </div>
            <div class="col-sm-4 col-4"></div>
        </div>
    </div> -->
        <div class="search-wrap section">
            <!-- <mat-tab-group  animationDuration="0ms">
            <mat-tab label="Users ({{UserCount}})"><app-userlist></app-userlist></mat-tab>
            <mat-tab label="Teams ({{TeamCount}})"><app-teamlist></app-teamlist></mat-tab>
        </mat-tab-group>         -->
            <!-- Nav tabs -->
            <!-- <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
            <a class="nav-link active" data-toggle="tab" href="#users">Users
                (<span>{{UserCount}}</span>)
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#team">Teams
                (<span>{{TeamCount}}</span>)
            </a>
        </li>
    </ul>

    <div class="tab-content">
        <div id="users" class="tab-pane active">
            <app-userlist></app-userlist>
        </div>
        <div id="team" class="tab-pane fade"><br>
            <app-teamlist></app-teamlist>
        </div>
    </div> -->

            <ul class="nav nav-tabs user-nav" role="tablist">
                <li class="nav-item" role="presentation">
                    <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#users" type="button"
                        role="tab" aria-controls="usera" aria-selected="true" data-testid="viewclient-user-button" (click)="switchClass('Users')">
                        Users (<span>{{userCount}}</span>)
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#team" type="button"
                        role="tab" aria-controls="team" aria-selected="false" data-testid="viewclient-team-button" (click)="switchClass('Teams')">
                        Teams (<span>{{teamCount}}</span>)
                    </button>
                </li>
            </ul>

            <div class="tab-content" *ngIf="isDataLoaded">
                <div id="users" class="tab-pane active" role="tabpanel">
                    <app-userlist (loaded)="onUserListLoaded()" [isWebPageToggleEnabled]="isWebPageToggleEnabled"></app-userlist>
                </div>
                <div id="team" class="tab-pane fade" role="tabpanel"><br>
                    <app-teamlist [inReportTypeClient]="inReportTypeClient" [inPriorityClient]="inPriorityClient" [inTurnaroundTimeClient]="inTurnaroundTimeClient" [isWebPageToggleEnabled]="isWebPageToggleEnabled" [stReportTypesClient]="stReportTypesClient" [flgIsEmailOnPublishClient]="flgIsEmailOnPublishClient" (loaded)="onTeamListLoaded()"></app-teamlist>
                </div>
            </div>

        </div>
